import { Component, computed, inject, input, output } from '@angular/core';
import { IconComponent } from '../icons/icon.component';
import { IconNameType } from '../icons/icon-name-type.enum';
import { Address } from '../../core/models/core/address.model';
import { AccountAddressesService } from '../../core/services/account/account-addresses.service';
import { IconUtils } from '../../core/utils/icon-utils';
import { AuditService } from '../../core/services/audit.service';

@Component({
  selector: 'cwo-temp-address',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './temp-address.component.html',
  styleUrl: './temp-address.component.scss'
})
export class TempAddressComponent {
  accountAddressesService = inject(AccountAddressesService);
  private auditService = inject(AuditService);
  address = input<Address>();

  readonly editAddress = output<boolean>();
  readonly tempAddressIsSaved = output<boolean>();

  addressInfo = computed(() => {
    return this.address() ? `${this.address()!.street}, ${this.address()!.city}, ${this.address()!.state?.toUpperCase()} ${this.address()!.zip}` : undefined;
  });
  iconName = computed(() => IconUtils.calcAddressIcon(this.address()?.addressType));
  iconNameType = IconNameType;
  savedTempAddress = false;

  editOrderAddress() {
    this.editAddress.emit(this.savedTempAddress);
  }

  saveToAddressBook() {
    if(this.address()) this.accountAddressesService.addAddress(this.address()!).subscribe(() => {
      this.savedTempAddress = true;
      this.auditService.createAudit(() => `New address has been created: {addressName: ${this.address()?.name}, fullAddress: ${this.address()?.street}, ${this.address()?.city}, ${this.address()?.state} ${this.address()?.zip}, ${this.address()?.diff1 && `${this.address()?.diff1}: ${this.address()?.value1}`}${this.address()?.diff2 ? `, ${this.address()?.diff2}: ${this.address()?.value2}` : ''}}`);
      this.tempAddressIsSaved.emit(true);
    })
  }

}
